/*
 * Smoothly scrolls the page to the first invalid field inside the lead form
 * after Turbo renders a response with validation errors (422 Unprocessable Entity).
 *
 * Behavior:
 * - Detects whether the lead form (#lead-form) contains validation errors.
 * - If no errors exist → do nothing.
 * - If errors exist → scroll to the first invalid field so that it is fully visible.
 * - Uses different scroll offsets for mobile and desktop for better usability.
 * - Uses requestAnimationFrame + small delay to ensure layout is stable after Turbo render.
 */
function scrollToLeadForm() {
  // Find the global SimpleForm error notification (top-level error banner)
  const errorBlock = document.querySelector("#lead-form > div.alert.alert-danger");
  if (!errorBlock) {
    return;
  }

  // Perform smooth scroll after DOM has settled
  window.requestAnimationFrame(() => {
    setTimeout(() => {
      const rect = errorBlock.getBoundingClientRect();
      const top = window.scrollY + rect.top;
      window.scrollTo({
        top: Math.max(top, 0),
        behavior: "smooth",
      });
    });
  });
}

// Bind scroll handler on Turbo navigation events
document.addEventListener("turbo:load", scrollToLeadForm);
document.addEventListener("turbo:render", scrollToLeadForm);
